export enum AutopsyActStatus {
  DRAFT = 'DRAFT',
  SIGNED = 'SIGNED',
}

export const AutopsyActStatusLabel: Record<AutopsyActStatus, string> = {
  [AutopsyActStatus.DRAFT]: 'Черновик',
  [AutopsyActStatus.SIGNED]: 'Подписан',
};

export const AutopsyActStatusColor: Record<AutopsyActStatus, string> = {
  [AutopsyActStatus.DRAFT]: 'default',
  [AutopsyActStatus.SIGNED]: 'green',
};

// Стадия обработки записи вскрытия: распознавание речи и раскладка текста по разделам акта
export enum ProcessingStage {
  QUEUED = 'QUEUED',
  TRANSCRIBING = 'TRANSCRIBING',
  EXTRACTING = 'EXTRACTING',
  DONE = 'DONE',
  FAILED = 'FAILED',
}

export const ProcessingStageLabel: Record<ProcessingStage, string> = {
  [ProcessingStage.QUEUED]: 'В очереди',
  [ProcessingStage.TRANSCRIBING]: 'Распознавание',
  [ProcessingStage.EXTRACTING]: 'Раскладка по разделам',
  [ProcessingStage.DONE]: 'Готово',
  [ProcessingStage.FAILED]: 'Ошибка',
};

export const ProcessingStageColor: Record<ProcessingStage, string> = {
  [ProcessingStage.QUEUED]: 'default',
  [ProcessingStage.TRANSCRIBING]: 'processing',
  [ProcessingStage.EXTRACTING]: 'processing',
  [ProcessingStage.DONE]: 'success',
  [ProcessingStage.FAILED]: 'error',
};

// Обработка ещё идёт: карточку и список нужно периодически обновлять
export const isProcessingInProgress = (stage?: ProcessingStage | null): boolean =>
  !!stage && stage !== ProcessingStage.DONE && stage !== ProcessingStage.FAILED;

// Откуда берётся описание вскрытия при создании акта
export enum AutopsySource {
  UPLOAD = 'UPLOAD',
  RECORD = 'RECORD',
  TEXT = 'TEXT',
}

export const AutopsySourceLabel: Record<AutopsySource, string> = {
  [AutopsySource.UPLOAD]: 'Загрузить запись',
  [AutopsySource.RECORD]: 'Записать с микрофона',
  [AutopsySource.TEXT]: 'Ввести текст вручную',
};
